import SearchIcon from '@mui/icons-material/Search';
import { Box, InputAdornment, TextField } from '@mui/material';
import React from 'react';

export const SearchBarWithNumber = ({
    onChange,
    fullWidth,
    totalCount,
    initialValue,
    ...props
}: {
    placeholder?: string;
    onChange?: (value: string) => void;
    fullWidth?: boolean;
    totalCount?: number;
    initialValue?: string;
}) => {
    const [searchValue, setSearchValue] = React.useState(initialValue ?? '');

    React.useEffect(() => {
        if (initialValue !== undefined) {
            setSearchValue(initialValue);
        }
    }, [initialValue]);

    const handleChange = event => {
        setSearchValue(event.target.value);
        setTimeout(() => {
            onChange?.(event.target.value);
        }, 300);
    };

    return (
        <TextField
            placeholder={props.placeholder || 'Rechercher'}
            variant="outlined"
            value={searchValue}
            onChange={handleChange}
            fullWidth
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <Box
                            sx={{
                                color: theme => theme.palette.textPrimary.main,
                                fontWeight: 400,
                                fontSize: '14px',
                                lineHeight: '20px',
                                minWidth: '30px',
                                textAlign: 'center',
                            }}>
                            {totalCount}
                        </Box>
                    </InputAdornment>
                ),
                sx: {
                    borderRadius: '2rem',
                    color: theme => theme.palette.neutralGray.main,
                    fontWeight: 500,
                    fontSize: '16px',
                    lineHeight: '20px',
                    border: theme => `2px solid ${theme.palette.border.main}`,
                    width: '100%',
                    '::placeholder': {
                        color: theme => theme.palette.neutralGray.main,
                        fontWeight: 500,
                        fontSize: '16px',
                        lineHeight: '20px',
                    },
                },
            }}
            sx={{
                width: fullWidth ? '100%' : '270px',
                minWidth: '313px',
                height: '48px',
                '& .MuiOutlinedInput-input': {
                    py: '12px',
                    pl: 0.5,
                    borderRight: theme => `2px dashed ${theme.palette.border.main}`,
                },
                '& .MuiOutlinedInput-root': {
                    backgroundColor: theme => theme.palette.background.paper,
                    borderRadius: '2rem',
                    '& fieldset': {},
                    '&:hover fieldset': {},
                    '&.Mui-focused fieldset': {},
                    '& .MuiInputBase-input::placeholder': {},
                },
            }}
        />
    );
};
